import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import propTypes from 'prop-types';
import PortalIcon from '../../../../Assets/portalGuyIcon.png';
import { StyledButton } from '../../../../Components/Generics.styled';

const CongratulationsContainer = styled.div`
    margin-top: 100px;
    display: flex;
    height: 700px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    font-size: 36px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const SubText = styled.div`
    font-size: 26px;
    letter-spacing: 0px;
    color: green;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    text-align: center;
`;

const ImageSection = styled.img`
    margin-top: 30px;
    height: 700px;
    width: 500px;
    margin-left: auto;
    margin-right: auto;
`;
const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: 500px;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;
const Congratulations = (props) => {
    const { setPageIndex, setCampaignData, campaignData } = props;
    const history = useHistory();

    const createNewCampaignRoute = () => {
        setPageIndex(0);
    };

    return (
        <CongratulationsContainer>
            <Title>Congratulations!</Title>
            <SubText>Your campaign is scheduled to run</SubText>
            <ImageSection src={PortalIcon} />
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => createNewCampaignRoute()}
                >
                    Create A New Campaign
                </StyledButton>
            </StyledNavButtons>
        </CongratulationsContainer>
    );
};

Congratulations.propTypes = {
    setPageIndex: propTypes.func,
    setCampaignData: propTypes.func,
    campaignData: propTypes.shape({
        stripeCustomerId: propTypes.string,
        stripePaymentId: propTypes.string,
        advertiserId: propTypes.number,
        agencyId: propTypes.number,
    }),
};

Congratulations.defaultProps = {
    setPageIndex: () => {},
    setCampaignData: () => {},
};

export default Congratulations;
